
import * as ipxRuntime$yWGMIGo4jOlahvmli1hUKPuQex9jXvyMs_iAhlGRO7Y from '/usr/src/app/node_modules/.pnpm/@nuxt+image@1.10.0_db0@0.3.4_ioredis@5.8.2_supports-color@10.2.2__magicast@0.5.1/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "clinicLogo": {
      "modifiers": {
        "width": 160,
        "height": 160,
        "fit": "contain",
        "background": "#FFFFFF"
      }
    }
  },
  "provider": "ipx",
  "domains": [
    "api.vetsy.test",
    "vetsy-api.waxim.ru",
    "vetsy.ru",
    "api.vetsy.ru",
    "storage.yandexcloud.net",
    "s3.ru1.storage.beget.cloud"
  ],
  "alias": {
    "/vetsy": "http://undefined",
    "/storageTest": "https://vetsy-api.waxim.ru/storage",
    "/storage": "https://api.vetsy.ru/storage"
  },
  "densities": [
    1,
    2,
    1,
    2
  ],
  "format": [
    "avif",
    "webp",
    "jpeg",
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$yWGMIGo4jOlahvmli1hUKPuQex9jXvyMs_iAhlGRO7Y, defaults: {"maxAge":31536000,"sharpOptions":{"autoOrient":true}} }
}
        